module.exports = __webpack_public_path__ + "static/media/mobile_image.95b247bf.png";